import { render, staticRenderFns } from "./PaymentBanner.vue?vue&type=template&id=639e9534"
import script from "./PaymentBanner.vue?vue&type=script&lang=js"
export * from "./PaymentBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports